import {SVGProps} from 'react';

interface AttemptsIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const AttemptsIcon = ({className, ...props}: AttemptsIconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <polyline points="23 4 23 10 17 10" />
    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
  </svg>
);
